module.exports = __webpack_public_path__ + "static/media/skulls.c6c207dd.gif";